import { type PaymentType, type ProductData } from '@/stores/productStore';

export const upgradeSalesByPaymentType: Partial<Record<PaymentType, ProductData['upgradeSales']>> = {
  free: [],
  oneTime: [
    { feature: 'sales_recovery', recoveryEmailSenderName: '' },
    { feature: 'multiple_cards' },
    { feature: 'combined_payment' },
    { feature: 'installments_without_limitation' },
    { feature: 'installments_without_interest' }
  ],
  // subscription: [
  //   { feature: 'sales_recovery', recoveryEmailSenderName: '' },
  //   { feature: 'multiple_cards' },
  //   { feature: 'combined_payment' },
  //   { feature: 'installments_without_limitation' },
  //   { feature: 'installments_without_interest' }
  // ],
  open: [{ feature: 'multiple_cards' }, { feature: 'combined_payment' }]
};
